// // src/App.jsx
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Layout from "./components/Layout";
// import RequireAuth from "./RequireAuth";
// import Login from "./pages/Login";

// import Dashboard from "./pages/Dashboard";
// import EmployeeList from "./pages/EmployeeList";
// import EmployeeForm from "./pages/EmployeeForm";
// import PayrollUpload from "./pages/PayrollUpload";
// import PayslipList from "./pages/PayslipList";
// import AdminDailySheet from "./pages/AdminDailySheet";


// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Public route */}
//         <Route path="/login" element={<Login />} />

//         {/* All other routes require auth */}
//         <Route
//           path="/*"
//           element={
//             <RequireAuth>
//               <Layout>
//                 <Routes>
//                   <Route path="/dashboard" element={<Dashboard />} />
//                   <Route path="/employees" element={<EmployeeList />} />
//                   <Route
//                     path="/employees/new"
//                     element={<EmployeeForm mode="create" />}
//                   />
//                   <Route
//                     path="/employees/:id/edit"
//                     element={<EmployeeForm mode="edit" />}
//                   />
//                   <Route
//                     path="/payroll/upload"
//                     element={<PayrollUpload />}
//                   />
//                   <Route path="/payslips" element={<PayslipList />} />
//                   <Route path="/daily-sheet-admin" element={<AdminDailySheet />} />
//                 </Routes>
//               </Layout>
//             </RequireAuth>
//           }
//         />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;





// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import RequireAuth from "./RequireAuth";
import Login from "./pages/Login";

import Dashboard from "./pages/Dashboard";
import EmployeeList from "./pages/EmployeeList";
import EmployeeForm from "./pages/EmployeeForm";
import PayrollUpload from "./pages/PayrollUpload";
import PayslipList from "./pages/PayslipList";
import AdminDailySheet from "./pages/AdminDailySheet";
import Holidays from "./pages/Holidays";
import Newsletters from "./pages/Newsletters";
import { getAuthSession } from "./auth";

const RoleGuard = ({ allow, children }) => {
  const session = getAuthSession();
  const role = session?.role;
  if (!allow.includes(role)) {
    // Redirect manager to daily sheet, admin to dashboard
    return (
      <Navigate
        to={role === "manager" ? "/daily-sheet-admin" : "/dashboard"}
        replace
      />
    );
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* All other routes require auth */}
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route
                    path="/dashboard"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <Dashboard />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/employees"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <EmployeeList />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/employees/new"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <EmployeeForm mode="create" />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/employees/:id/edit"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <EmployeeForm mode="edit" />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/payroll/upload"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <PayrollUpload />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/payslips"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <PayslipList />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/newsletters"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <Newsletters />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/holidays"
                    element={
                      <RoleGuard allow={["admin"]}>
                        <Holidays />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="/daily-sheet-admin"
                    element={
                      <RoleGuard allow={["admin", "manager"]}>
                        <AdminDailySheet />
                      </RoleGuard>
                    }
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/daily-sheet-admin" replace />}
                  />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
